import BackBtn from 'components/global/BackBtn';
import Pagination from 'components/global/pagination';
import Search from 'components/global/Search';
import Sidebar from 'components/global/sidebar'
import Navbar from 'components/user/navbar'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';

const MyCompaigns = () => {
    
    return (
        <div className="w-full pb-20 md:px-0 px-4 pt-24  ">
            <Navbar />
            <div>
                <Sidebar />
            </div>
            <div className="w-full pl md:pr-20 ">
                <div className="light-shadow flex sm:items-center gap-4 sm:flex-row flex-col-reverse justify-between w-full py-4 px-4 rounded-lg">
                    <div className='flex items-center gap-3'>
                        <p className='font-semibold text-dark'>Sort By</p>
                        <select className='rounded-full border focus:border-primary py-2 px-2 w-[250px] outline-none'>
                            <option value="null">Select__</option>
                            <option value="1">Option1</option>
                            <option value="2">Option2</option>
                            <option value="3">Option3</option>
                            <option value="4">Option4</option>
                        </select>
                    </div>
                    <BackBtn />
                </div>
                <div className='light-shadow mt-8 rounded-lg'> 
                    <Table>
                        <Thead className='gradient-bg'>
                            <Tr>
                                <Th>Compaign Name</Th>
                                <Th>Created</Th>
                                <Th>Status</Th>
                                <Th>Plays</Th>
                                <Th>Research</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                [...Array(6).keys()].map((item) => (
                                    <Tr key={item} >
                                        <Td>Mind Units</Td>
                                        <Td>02-01-2022-01:03AM</Td>
                                        <Td>Draft</Td>
                                        <Td>0</Td>
                                        <Td>0</Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                    <div>
                        <Pagination />
                    </div>
                </div>

            </div>
        </div>
    )
}

export default MyCompaigns